export default __webpack_public_path__ + "static/media/Goz_Attila_CV_Engineer.513c0d30.pdf";